import {
    Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { EditorTextChangeEvent } from "primeng/editor";
import { FileSelectEvent } from "primeng/fileupload";
import { Observable, ReplaySubject } from "rxjs";

import { StorageService } from "../../../../core/helper/storage.service";
import { ActionType } from "../../../../core/models/Enums/actionType.enum";
import { ActionTypes } from "../../../../core/models/Enums/actionTypes.enum";
import { ArchivedStatus } from "../../../../core/models/Enums/archivedStatus.enum";
import { FeedbackType } from "../../../../core/models/Enums/feedbackType.enum";
import { ResponseStatus } from "../../../../core/models/Enums/responseStatus.enum";
import { UserRole } from "../../../../core/models/Enums/userRole.enum";
import { GenericResponseDto } from "../../../../core/models/genericResponseDto.model";
import { ConfigurationTemplateService } from "../../../../core/services/vendor/configuration-template.service";
import { DocumentService } from "../../../../core/services/vendor/document.service";
import { FeedbackService } from "../../../../core/services/vendor/feedback.service";
import { VendorArchiveService } from "../../../../core/services/vendor/vendor-archive.service";
import { VendorDocumentService } from "../../../../core/services/vendor/vendor-document.service";
import { WorkflowService } from "../../../../core/services/vendor/workflow.service";
import { Feedback } from "../../../../shared/models/feedback.model";
import { SummaryPost } from "../../../../shared/models/summary-post.model";
import { Workflow } from "../../../../shared/models/workflow.model";
import { EmailAttachment } from "../../../dashboard/components/vendor-signup/models/email-attachment.model";
import { EmailTemplate } from "../../../dashboard/components/vendor-signup/models/email-template.model";
import { EmailTemplateForm } from "../../../dashboard/components/vendor-signup/models/email-template-form.models";
import { EmailAttachmentEnum } from "../../../dashboard/components/vendor-signup/models/Enums/emailAttachmentEnum.enum";
import { EmailTemplateEnum } from "../../../dashboard/components/vendor-signup/models/Enums/emailTemplateEnum.enum";
import { EmailVariable } from "../../../document-templates/components/document-templates/models/email-variable.model";
import { EmailTemplateType } from "../../../document-templates/components/document-templates/models/Enums/email-template-type.enum";
import { EmailTypeNames } from "../../../document-templates/components/document-templates/models/Enums/email-type-names.enum";

@Component({
    selector: "app-vendor-summery",
    templateUrl: "./vendor-summery.component.html",
    styleUrl: "./vendor-summery.component.scss"
})
export class VendorSummeryComponent implements OnInit, OnChanges {
    @Output() saveAndContinue: EventEmitter<void> = new EventEmitter<void>();
    @Output() currentWorkflowStatus = new EventEmitter<string>();

    @Input() isPreferedPartner!: any;
    @Input() isRebateFilled!: boolean;
    @Input() isDocumentsUploaded!: boolean;
    @Input() isProductLiabilityInsuranceFilled!: boolean;
    @Input() isOtherCertificatesFilled: boolean = true;
    archiveStatus: number | null = null;
    @Input() selectedYear: number | null = null;
    @Input() fromArchive: boolean = false;
    @Input() reviewStatus: string | undefined;
    @Input() feedbackObject: Feedback[] = [];
    @Input() inQueueValue = false;
    @Input() certificationSignatureChecked = false;
    @Input() documents: any[] = [];
    @Input() pendingReviewerDocumentIds: number[] = [];

    visible: boolean = false;
    public routerObject;
    userRole = "";
    accountNumber = "";
    vendorInformation = false;
    vendorDocuments = false;
    vendorContacts = false;
    vendorCompliance = false;
    internalNotes? = "";
    vendorNotes? = "";
    navigateBack = "";
    navigateNext = "";
    queryParams = {};
    LoggedInUserRole = UserRole;

    feedbackType = "";
    internalNotesToSave = "";
    vendorNotesToSave = "";

    actionType = "";
    actionTypeEnum = ActionType;
    ArchivedStatus = ArchivedStatus;

    inprogress: boolean = false;
    fillAndSignInProgress: boolean = false;
    reviewerSignatureInProgress: boolean = false;

    showEmailTemplate: boolean = false;
    emailVariables: EmailVariable[] = [];
    listOfAttachments: EmailAttachment[] = [];
    selectedAttachmentIndex: number = 0;
    emailTemplateType = "";
    emailTemplateName = "";
    fileBase64Index = 0;

    EmailTemplateEnum = EmailTemplateEnum;

    timeOutForRedirect: any;
    toggleApprovalDialog: boolean = false;
    isReviewerSignaturesRequired: boolean = false;

    UserRole = UserRole;
    @Output() refreshVendorInformation = new EventEmitter<string>();
    sendPendingEnvelopeInProgress = false;
    pendingEnvelopeId: string | null = null;
    fillAndSignInternalInProgress = false;

    showMainContactDialog: boolean = false;
    mainContactEmail: string = "";
    mainContactEmailInvalid: boolean = false;
    loadingMainContact: boolean = false;

    emailTemplateForm = this.fb.group<EmailTemplateForm>({
        [EmailTemplateEnum.Name]: this.fb.control<string | null>("", { nonNullable: true }),
        [EmailTemplateEnum.EmailSubject]: this.fb.control<string | null>("", { nonNullable: true }),
        [EmailTemplateEnum.EmailBody]: this.fb.control<string | null>("", { nonNullable: true }),
        [EmailTemplateEnum.Attachments]: this.fb.control<EmailAttachment[] | null>([], { nonNullable: true })
    });

    constructor(
        private router: Router,
        private feedbackService: FeedbackService,
        private workflowService: WorkflowService,
        private storageService: StorageService,
        private route: ActivatedRoute,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private fb: FormBuilder,
        private configurationTemplateService: ConfigurationTemplateService,
        private archiveService: VendorArchiveService,
        private documentService: DocumentService,
        private vendorDocumentService: VendorDocumentService
    ) {
        this.routerObject = router;
    }

    getRenewalStatus(): boolean {
        return this.archiveService.getRenewalStatus();
    }

    ngOnInit() {
        this.archiveStatus = this.archiveService.archiveStatus();
        const userDetails: string | null = this.storageService.get("userDetails");
        const { userRole } = JSON.parse(userDetails ?? "");
        this.userRole = userRole;
        this.setNavigation();
        if (userRole === UserRole.Internal || userRole === UserRole.Admin) {
            this.route.queryParamMap.subscribe((param: any) => {
                const accountNumberParam = param.params.accountNumber;
                this.accountNumber = accountNumberParam;
                if (Object.keys(param.params).length === 0) {
                    this.router.navigate(["dashboard"]);
                }
            });
            // this.fetchPendingReviewerEnvelope();
        } else {
            const accountNumber = JSON.parse(userDetails ?? "").vendorAccountNumber;
            this.accountNumber = accountNumber;
        }
        this.getCurrentWorkflow();
        this.feedbackService.getVendorInfoFeedback().subscribe((value: Feedback[]) => {
            this.feedbackObject = value;
        });
        this.initializeComments();

        if (this.router.url.includes("vendor-information")) {
            this.feedbackType = FeedbackType.Vendor_Information;
        }
        this.emailTemplateName = EmailTypeNames.WorkFlow;
        this.emailTemplateType = EmailTemplateType.WorkFlow;
        this.getEmailTemplateByTemplateName();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Update certification status whenever documents input changes
        if (changes["documents"] && changes["documents"].currentValue) {
            this.documentService.updateAllCertifiedStatus(
                changes["documents"].currentValue,
                this.selectedYear ?? undefined
            );
        }
    }

    showDialog() {
        if (this.actionType === this.actionTypeEnum.ApprovalInProgress) {
            return;
        }
        this.visible = true;
    }

    onChangeInternalNotes(eventObj: EditorTextChangeEvent) {
        const event = {
            target: {
                value: eventObj.htmlValue
            }
        };
        this.internalNotesToSave = event.target.value;
        this.vendorNotesToSave = this.vendorNotes ?? "";
        /* eslint-disable no-param-reassign */
        if (this.router.url.includes("vendor-information")) {
            if (!this.vendorInformation) {
                this.feedbackObject.push({
                    feedbackType: FeedbackType.Vendor_Information,
                    notesForInitiator: event.target.value,
                    selfNotes: "",
                    archiveYear: this.selectedYear
                });
                this.vendorInformation = true;
            } else {
                this.feedbackObject.forEach((item: Feedback) => {
                    if (item.feedbackType === FeedbackType.Vendor_Information) {
                        item.notesForInitiator = event.target.value;
                    }
                    return 0;
                });
            }
            this.feedbackService.setVendorInfoFeedback(this.feedbackObject);
        }
        this.feedbackService.setVendorInfoFeedback(this.feedbackObject);
        /* eslint-enable no-param-reassign */
    }

    onChangeVendorNotes(eventObj: EditorTextChangeEvent) {
        const event = {
            target: {
                value: eventObj.htmlValue
            }
        };
        this.vendorNotesToSave = event.target.value;
        this.internalNotesToSave = this.internalNotes ?? "";
        /* eslint-disable no-param-reassign */
        if (this.router.url.includes("vendor-information")) {
            if (!this.vendorInformation) {
                this.feedbackObject.push({
                    feedbackType: FeedbackType.Vendor_Information,
                    selfNotes: event.target.value,
                    notesForInitiator: "",
                    archiveYear: this.selectedYear
                });
                this.vendorInformation = true;
            } else {
                this.feedbackObject.forEach((item: Feedback) => {
                    if (item.feedbackType === FeedbackType.Vendor_Information) {
                        item.selfNotes = event.target.value;
                    }
                    return 0;
                });
            }
            this.feedbackService.setVendorInfoFeedback(this.feedbackObject);
        }
        /* eslint-enable no-param-reassign */
    }

    onClickBack() {
        this.visible = false;
    }

    onClickSendFeedback() {
        const data: SummaryPost = {
            vendorAccountNo: this.accountNumber,
            actionType: ActionTypes.SendFeedback,
            feedbacks: this.feedbackObject,
            archiveYear: this.selectedYear ?? this.getCurrentYear()
        };
        this.inprogress = true;
        this.workflowService.workflowSummaryPost(data).subscribe((response:
        GenericResponseDto<SummaryPost>) => {
            this.inprogress = false;
            if (response.status === ResponseStatus.Success) {
                this.getCurrentWorkflow();
                this.messageService.clear();
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Feedback Succesfully Sent"
                });
                this.visible = false;
                // this.router.navigate(["vendor/reviews"]);
                this.redirectTo("vendor/reviews");
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Failed",
                    detail: response.message
                });
            }
        });
    }

    initializeComments() {
        if (this.router.url.includes("vendor-information")) {
            this.feedbackObject.forEach((item: Feedback) => {
                if (item.feedbackType === FeedbackType.Vendor_Information) {
                    this.internalNotes = item.notesForInitiator; this.vendorNotes = item.selfNotes;
                    this.vendorInformation = true;
                }
                return 0;
            });
        }
    }

    redirectFunction() {
        this.router.navigate(["vendor/dashboard"]);
    }

    onClickSubmitReview() {
        const postData: SummaryPost = {
            vendorAccountNo: this.accountNumber,
            actionType: ActionTypes.Review,
            archiveYear: this.selectedYear ?? this.getCurrentYear()
        };
        this.inprogress = true;
        this.workflowService.workflowSummaryPost(postData).subscribe((response:
        GenericResponseDto<SummaryPost>) => {
            this.inprogress = false;
            if (response.status === ResponseStatus.Success) {
                this.getCurrentWorkflow();
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: response.message
                });

                this.redirectTo("vendor/dashboard");
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Failed",
                    detail: response.message
                });
            }
        });
    }

    confirmSubmitForReview() {
        this.confirmationService.confirm({
            message: "Are you sure you want to submit?",
            header: "Confirmation",
            icon: "pi pi-exclamation-triangle",
            acceptIcon: "none",
            rejectIcon: "none",
            rejectButtonStyleClass: "p-button-text",
            accept: () => {
                this.onClickSubmitReview();
            },
            reject: () => {
            }
        });
    }

    setNavigation() {
        if (this.userRole === UserRole.Internal || this.userRole === UserRole.Admin) {
            this.route.queryParamMap.subscribe((param: any) => {
                this.queryParams = { accountNumber: param.params.accountNumber };
            });
        } else {
            this.queryParams = {};
        }
        const currentUrl = this.router.url;
        if (currentUrl.includes("dashboard")) {
            this.navigateBack = "/";
            this.navigateNext = "/vendor/vendor-information";
        }
        if (currentUrl.includes("vendor-information")) {
            if (this.userRole === UserRole.Internal || this.userRole === UserRole.Admin) {
                this.navigateBack = "/vendor-rebates-report-dashboard";
            } else {
                this.navigateBack = "/vendor/dashboar";
            }
            this.navigateNext = "/vendor/summary";
        }
        if (currentUrl.includes("summary")) {
            this.navigateBack = "/vendor/vendor-information";
            this.navigateNext = "/";
        }
    }

    onApprove() {
        if (this.actionType === this.actionTypeEnum.ApprovalInProgress) {
            return;
        }
        const data: SummaryPost = {
            vendorAccountNo: this.accountNumber,
            actionType: ActionTypes.Approve,
            archiveYear: this.selectedYear ?? this.getCurrentYear(),
            inQueue: this.inQueueValue,
        };

        if (this.isPreferedPartner && this.isPreferedPartner === "ALL") {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Failed",
                detail: "Preferred Partner Level value cannot"
                    + " be 'All' when finalizing approvals for vendor application. Please set it to to either PP,"
                    + " PPD or DSC."
            });
            this.visible = false;
            return;
        }
        // Check if all documents are certified before approval
        this.documentService.allCertified$.subscribe((allCertified) => {
            if (!allCertified) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Failed",
                    detail: "All documents must be certified before approval."
                });
                return;
            }
            this.inprogress = true;
            this.workflowService.workflowSummaryPost(data).subscribe((response: GenericResponseDto<SummaryPost>) => {
                this.inprogress = false;
                if (response.status === ResponseStatus.Success
                    || response.status === ResponseStatus.ReviewerSignaturesRequired) {
                    // Set flag for reviewer signatures requirement
                    this.isReviewerSignaturesRequired = response.status === ResponseStatus.ReviewerSignaturesRequired;
                    this.toggleApprovalDialog = true;
                    this.getCurrentWorkflow();
                    this.messageService.clear();

                    // Check if the response indicates reviewer signatures required
                    if (this.isReviewerSignaturesRequired) {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Email has been sent to the reviewer for document signatures. "
                                + "The approval process will continue once all signatures are collected."
                        });
                    } else {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: response.message
                        });
                    }
                    // this.router.navigate(["vendor/reviews"]);
                    // this.redirectTo("vendor/reviews");
                } else {
                    this.messageService.clear();
                    this.messageService.add({
                        severity: "error",
                        summary: "Failed",
                        detail: response.message
                    });
                }
            });
        }).unsubscribe();
    }

    onReject() {
        const data: SummaryPost = {
            vendorAccountNo: this.accountNumber,
            actionType: ActionTypes.Reject,
            archiveYear: this.selectedYear ?? this.getCurrentYear(),
            inQueue: this.inQueueValue,
        };
        this.inprogress = true;
        const updatedData = {
            ...data,
            emailSubject: this.emailTemplateForm.value[EmailTemplateEnum.EmailSubject],
            emailBody: this.emailTemplateForm.value[EmailTemplateEnum.EmailBody]
        };
        this.workflowService.workflowSummaryPost(updatedData).subscribe((response: GenericResponseDto<SummaryPost>) => {
            this.inprogress = false;
            if (response.status === ResponseStatus.Success) {
                this.getCurrentWorkflow();
                this.messageService.clear();
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: response.message
                });
                // this.router.navigate(["vendor/reviews"]);
                this.redirectTo("vendor/reviews");
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Failed",
                    detail: response.message
                });
            }
        });
    }

    rejectPopup() {
        if (this.actionType === this.actionTypeEnum.ApprovalInProgress) {
            return;
        }
        this.getEmailTemplateByTemplateName();
        this.showEmailTemplate = true;
    }

    onClickBackButton() {
        if (this.navigateBack === "/dashboard" || this.navigateBack === "/vendor/dashboard") {
            this.queryParams = {};
        }

        // Set the selected year in the archive service before navigating
        if (this.selectedYear) {
            this.archiveService.setSelectedYear(this.selectedYear);
        }

        this.router.navigate(
            [this.navigateBack],
            {
                queryParams: this.queryParams
            }
        );
    }

    onClickNextButton() {
        // Set the selected year in the archive service before navigating
        if (this.selectedYear) {
            this.archiveService.setSelectedYear(this.selectedYear);
        }

        this.router.navigate(
            [this.navigateNext],
            {
                queryParams: this.queryParams,
                state: {
                    feedbackObject: JSON.stringify(this.feedbackObject)
                }
            }
        );
    }

    onSaveNotes() {
        const data: Feedback = {
            vendorAccountNo: this.accountNumber,
            selfNotes: this.vendorNotesToSave,
            notesForInitiator: this.internalNotesToSave,
            feedbackType: this.feedbackType,
            archiveYear: this.selectedYear ?? this.getCurrentYear()
        };
        this.workflowService.postWorkflowFeedback(data).subscribe((response: any) => {
            if (response.status === ResponseStatus.Success) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "Your feedback has been updated."
                });
            } else {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Failed",
                    detail: response.message
                });
            }
        });
    }

    onSaveAndContinue(): void {
        if (!this.isRebateFilled) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Failed",
                detail: "You must submit rebates to proceed."
            });
            return;
        }

        if (!this.isDocumentsUploaded) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Failed",
                detail: "You must upload all required documents to proceed."
            });
            return;
        }

        if (!this.isProductLiabilityInsuranceFilled) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Failed",
                detail: "You must upload Product Liability Insurance document to proceed."
            });
            return;
        }

        if (!this.certificationSignatureChecked) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please check the certification and provide your signature",
            });
            return;
        }

        if (this.isOtherCertificatesFilled === false) {
            this.messageService.clear();
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "You must fill all missings details in Other certifications to proceed."
            });
            return;
        }

        this.saveAndContinue.emit();
    }

    copyVariableValue(val: string) {
        const selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        const valUpdate = `%${val}%`;
        selBox.value = valUpdate;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
    }

    onFileSelected(event: FileSelectEvent) {
        this.fileBase64Index = 0;
        const fileList = event.files;
        if (!fileList) {
            return;
        }
        for (let i = 0; i < fileList.length; i += 1) {
            this.convertFile(fileList[i]).subscribe((base64) => {
                this.listOfAttachments[this.fileBase64Index][EmailAttachmentEnum.Base64] = base64;
                this.fileBase64Index += 1;
                this.emailTemplateForm.patchValue({ [EmailTemplateEnum.Attachments]: this.listOfAttachments });
            });
        }
    }

    convertFile(file: File): Observable<string> {
        const result = new ReplaySubject<string>(1);
        const reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onload = (event: any) => result.next(btoa(event.target.result.toString()));
        this.listOfAttachments.forEach((item: EmailAttachment) => {
            if (item.FileName === file.name) {
                this.messageService.clear();
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Some file(s) are already added and are descarded"
                });
            }
        });
        this.listOfAttachments.push({ [EmailAttachmentEnum.FileName]: file.name });
        return result;
    }

    onRemoveFile(event: any) {
        let indexOfFile = -1;
        this.listOfAttachments.forEach((item: EmailAttachment, index) => {
            if (event.file.name === item.FileName) {
                indexOfFile = index;
            }
        });
        this.listOfAttachments.splice(indexOfFile, 1);
    }

    getEmailTemplateByTemplateName() {
        this.configurationTemplateService
            .getEmailTemplateByTemplateName(this.emailTemplateName, this.emailTemplateType)
            .subscribe((response: GenericResponseDto<EmailTemplate>) => {
                if (response.status !== ResponseStatus.Success) {
                    return;
                }
                if (!response.data) {
                    return;
                }
                this.emailTemplateForm.patchValue(response.data);
                if (response.data.emailVariables) {
                    this.emailVariables = response.data.emailVariables;
                }
            });
    }

    redirectTo(route: string) {
        const interval = setInterval(() => {
            this.router.navigate([route]);
            clearInterval(interval);
        }, 5000);
    }

    getCurrentWorkflow() {
        this.workflowService.getWorkflowByAccountNumber(this.accountNumber, this.selectedYear ?? this.getCurrentYear())
            .subscribe((response: GenericResponseDto<Workflow>) => {
                if (response.status === ResponseStatus.Success) {
                    if (response.data) {
                        this.actionType = response.data.actionType ?? "";
                        this.currentWorkflowStatus.emit(response.data.actionType ?? "");

                        if (response.data.feedback) {
                            if (!this.feedbackObject.some((x) => x.archiveYear === this.selectedYear)) {
                                this.feedbackObject = response.data.feedback;
                                this.initializeComments();
                            }
                        }
                    }
                }
            });
    }

    backTo() {
        const isInternalOrAdmin = this.userRole === UserRole.Internal
            || this.userRole === UserRole.Admin;
        this.router.navigate([isInternalOrAdmin ? "/dashboard" : "/vendor/dashboard"]);
    }

    getCurrentYear(): number {
        return new Date().getFullYear();
    }

    shouldShowFillAndSignButton(): boolean {
        // Show button only for vendor users on vendor-information page
        if ((this.userRole !== UserRole.Vendor && this.userRole !== UserRole.SubVendor)
            || !this.router.url.includes("vendor-information")
            || (this.selectedYear && this.selectedYear < this.getCurrentYear())) {
            return false;
        }

        // Check if any document (excluding typeId 2 and 14) has hasChanges=false and vendorSign=false
        return this.documents.some((doc: any) => doc.typeId !== 2
            && doc.typeId !== 14
            && doc.hasChanges === false
            && doc.vendorSign === false);
    }

    areAllMandatoryDocumentsUploaded(): boolean {
        // Check if all mandatory documents (excluding ACH - typeId 2 and typeId 14) are uploaded
        const mandatoryDocuments = this.documents.filter((doc: any) => doc.typeId !== 2 && doc.typeId !== 14);

        if (mandatoryDocuments.length === 0) {
            return false;
        }

        // All mandatory documents must have a documentId (uploaded)
        return mandatoryDocuments.every(
            (doc: any) => doc.documentId !== null && doc.documentId !== undefined && doc.documentId !== ""
        );
    }

    onFillAndSignDocuments(): void {
        this.loadingMainContact = true;
        this.mainContactEmail = "";
        this.mainContactEmailInvalid = false;

        // Fetch main contact email from API
        this.vendorDocumentService.GetMainContact(this.accountNumber, this.selectedYear ?? undefined)
            .subscribe((response: GenericResponseDto<string>) => {
                this.loadingMainContact = false;
                if (response.status === ResponseStatus.Success && response.data) {
                    this.mainContactEmail = response.data;
                }
                this.showMainContactDialog = true;
            }, () => {
                this.loadingMainContact = false;
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Failed to fetch main contact email"
                });
            });
    }

    validateEmail(email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    onSubmitMainContact(): void {
        // Validate email
        if (!this.mainContactEmail || !this.mainContactEmail.trim()) {
            this.mainContactEmailInvalid = true;
            this.messageService.add({
                severity: "error",
                summary: "Validation Error",
                detail: "Main contact email is required"
            });
            return;
        }

        if (!this.validateEmail(this.mainContactEmail)) {
            this.mainContactEmailInvalid = true;
            this.messageService.add({
                severity: "error",
                summary: "Validation Error",
                detail: "Please enter a valid email address"
            });
            return;
        }

        this.mainContactEmailInvalid = false;
        this.fillAndSignInProgress = true;
        this.showMainContactDialog = false;

        this.vendorDocumentService.FillAndSign(
            this.accountNumber,
            this.mainContactEmail,
            this.selectedYear ?? undefined
        )
            .subscribe((response: GenericResponseDto<any>) => {
                this.fillAndSignInProgress = false;
                if (response.status === ResponseStatus.Success) {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: response.message || "Operation completed successfully"
                    });
                } else {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: response.message || "Failed to fill and sign documents"
                    });
                }
            }, (error) => {
                this.fillAndSignInProgress = false;
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: `An error occurred while processing the request: ${error.message || error}`
                });
            });
    }

    onCancelMainContactDialog(): void {
        this.showMainContactDialog = false;
        this.mainContactEmail = "";
        this.mainContactEmailInvalid = false;
    }

    fetchPendingReviewerEnvelope() {
        if (this.selectedYear && this.selectedYear < this.getCurrentYear()) {
            return;
        }

        this.vendorDocumentService.GetPendingReviewerEnvelopeId(this.accountNumber, this.selectedYear ?? undefined)
            .subscribe((response: GenericResponseDto<string>) => {
                if (response.status === "Success" && response.data !== "") {
                    this.pendingEnvelopeId = response.data;
                }
            }, () => {
                this.pendingEnvelopeId = null;
            });
    }

    onSendPendingEnvelopeToReviewer() {
        if (this.pendingEnvelopeId) {
            this.sendPendingEnvelopeInProgress = true;
            this.vendorDocumentService.RegenerateReviewerSigningUrl(this.pendingEnvelopeId, this.accountNumber)
                .subscribe({
                    next: (response: any) => {
                        if (response.status === "Success") {
                            this.messageService.add({
                                severity: "success",
                                summary: "Envelope Sent",
                                detail: response.message || "Envelope sent to reviewer."
                            });
                        } else {
                            this.messageService.add({
                                severity: "error",
                                summary: "Error",
                                detail: response.message || "Failed to send envelope."
                            });
                        }
                        this.sendPendingEnvelopeInProgress = false;
                    },
                    error: (error: any) => {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error?.message || "Failed to send envelope."
                        });
                        this.sendPendingEnvelopeInProgress = false;
                    }
                });
        }
    }

    shouldInternalShowFillAndSignButton() {
        // Show button only for internal/admin users on vendor-information page
        if ((this.userRole !== UserRole.Internal && this.userRole !== UserRole.Admin)
            || !this.router.url.includes("vendor-information")
            || (this.selectedYear && this.selectedYear < this.getCurrentYear())) {
            return false;
        }

        // Check if there are any pending reviewer documents
        return this.pendingReviewerDocumentIds && this.pendingReviewerDocumentIds.length > 0;
    }

    onFillAndSignInternalDocuments() {
        if (!this.pendingReviewerDocumentIds || this.pendingReviewerDocumentIds.length === 0) {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "No documents pending reviewer signature"
            });
            return;
        }

        this.fillAndSignInternalInProgress = true;
        this.vendorDocumentService.CreateReviewerEnvelopeByRecordId(
            this.pendingReviewerDocumentIds,
            this.selectedYear ?? undefined
        )
            .subscribe({
                next: (response: GenericResponseDto<any>) => {
                    this.fillAndSignInternalInProgress = false;
                    if (response.status === ResponseStatus.Success) {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: response.message || "Reviewer envelope created successfully"
                        });
                    } else {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: response.message || "Failed to create reviewer envelope"
                        });
                    }
                },
                error: (error: any) => {
                    this.fillAndSignInternalInProgress = false;
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.message || "An error occurred while creating the reviewer envelope"
                    });
                }
            });
    }
}
